import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { submit, isDirty, Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Progress from 'components/common/Progress';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';
import Button from 'components/common/Button';
import IconInfo from 'components/icons/IconInfo';
import Tooltip from 'components/common/Tooltip';

import { fetchUserNotificationSettings } from 'redux/modules/userNotificationSettings';

import NotificationsSettingsDialogForm from './NotificationsSettingsDialogForm';

const styles = theme => ({
  tableHead: {
    padding: '8px 40px',
    [theme.breakpoints.down('xs')]: {
      padding: '8px 8px',
    },
  },
  iconInfo: {
    display: 'inline-block',
    width: 14,
    height: 14,
    color: theme.palette.primary.A400,
    cursor: 'pointer',
    margin: '-2px 0 -2px 4px',
  },
  tooltip: {
    display: 'block',
  },
});

class NotificationsSettingsDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      limit: 10,
      offset: 0,
      triggerLoading: true,
    };

    this.onDialogEnter = this.onDialogEnter.bind(this);
    this.onDialogExited = this.onDialogExited.bind(this);
  }

  onDialogEnter() {
    this.props.actions.fetchUserNotificationSettings({
      triggerLoading: true,
    });
  }

  onDialogExited() {
    this.setState({
      offset: 0,
      triggerLoading: true,
    });
  }

  render() {
    const {
      open,
      loading,
      onClose,
      account,
      actions,
      userNotificationSettings,
      onSubmitSuccess,
      dirty,
      classes,
    } = this.props;
    const { advanced } = this.state;
    const initialValues = userNotificationSettings.reduce((accumulator, currentValue) => ({
        ...accumulator,
        [currentValue.ID]: {
          'Is All': currentValue.Active['Is All'],
          'Is Assigned': currentValue.Active['Is Assigned'],
          'Is Watcher': currentValue.Active['Is Watcher'],
        },
      }), {});
    return (
      <Dialog
        open={open}
        onClose={onClose}
        onEnter={this.onDialogEnter}
        onExited={this.onDialogExited}
        maxWidth="md"
      >
        <DialogTitle
          onCloseClick={onClose}
          secondaryContent={(
            <div className={classes.tableHead}>
              <Grid
                container
                justify="flex-end"
                spacing={16}
                wrap="nowrap"
              >
                <Grid
                  item
                  xs={12}
                  sm={10}
                >
                  <Grid
                    container
                    justify="flex-end"
                    spacing={16}
                    wrap="nowrap"
                  >
                    <Grid
                      item
                      xs={2}
                    >
                      <Tooltip
                        className={classes.tooltip}
                        content={
                          <Typography>
                            Notifications from all Patients in System
                          </Typography>
                        }
                        color="grey"
                        placement="top"
                      >
                        <Typography variant="caption">
                          All Charts
                          <IconInfo className={classes.iconInfo} />
                        </Typography>
                      </Tooltip>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                    >
                      <Tooltip
                        className={classes.tooltip}
                        content={
                          <Typography>
                            Notifications only from Patients that have orders which you are Assigned to
                          </Typography>
                        }
                        color="grey"
                        placement="top"
                      >
                        <Typography variant="caption">
                          Assigned
                          <IconInfo className={classes.iconInfo} />
                        </Typography>
                      </Tooltip>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                    >
                      <Tooltip
                        className={classes.tooltip}
                        content={
                          <Typography>
                            Notifications only from Patients that you are Watching
                          </Typography>
                        }
                        color="grey"
                        placement="top"
                      >
                        <Typography variant="caption">
                          Watched
                          <IconInfo className={classes.iconInfo} />
                        </Typography>
                      </Tooltip>
                    </Grid>
                  </Grid>       
                </Grid>
              </Grid>
            </div>
          )}
        >
          <Typography
            variant="title"
            color="secondary"
            align="center"
          >
            {`Notifications Settings for ${account['First Name']} ${account['Last Name']}`}
          </Typography>
        </DialogTitle>
        <DialogContent
          withScrollbars
          disableGutters
          fullHeight
        >
          {(loading > 0) ? (
            <Progress />
          ) : (
            <NotificationsSettingsDialogForm
              form={`${account.ID}-notificationsSettingsForm`}
              userNotificationSettings={userNotificationSettings}
              initialValues={initialValues}
              onSubmitSuccess={onSubmitSuccess}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            variant="raised"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (dirty) {
                actions.submit(`${account.ID}-notificationsSettingsForm`);
              } else {
                onClose();
              }
            }}
            variant="raised"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

NotificationsSettingsDialog.propTypes = {
  userNotificationSettings: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  loading: PropTypes.number.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }).isRequired,
  onSubmitSuccess: PropTypes.func,
  dirty: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    fetchUserNotificationSettings: PropTypes.func.isRequired,
  }).isRequired,
};

NotificationsSettingsDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
};

const mapStateToProps = store => ({
  userNotificationSettings: store.userNotificationSettings.data,
  loading: store.userNotificationSettings.loading,
  account: store.account,
  dirty: isDirty(`${store.account.ID}-notificationsSettingsForm`)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchUserNotificationSettings,
    submit,
  }, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(NotificationsSettingsDialog),
);



// WEBPACK FOOTER //
// ./src/components/home/NotificationsSettingsDialog/NotificationsSettingsDialog.js